import { actions, selectors, useDispatch } from '@sloyd/store-base';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { select, takeEvery } from 'saga-ts';
import { invokeEvent, l } from 'shared-base';
import { customEventChannel } from './channels/channel.customEvent';

type NavigationMethod = (to: string) => void;

let navigationMethod: NavigationMethod;

export const setNavigationMethod = (method: NavigationMethod) => {
  navigationMethod = method;
};

export function* onNavigation(event: any) {
  const { data } = event;
  const { path } = data;
}

export function* navEvent(event: any) {
  try {
    const { data } = event;
    const { path } = data;

    if (path.startsWith('http')) {
      window.open(path, '_blank');
      return;
    }

    // --- Meta Pixel ---
    // @ts-ignore
    if (window.fbq) {
      console.log('Tracking FB PageView:', location.pathname + location.search);
      // @ts-ignore
      window.fbq('track', 'PageView');
    }

    // --- Google Tag Manager ---
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    console.log('Pushing GTM virtualPageView:', location.pathname + location.search);
    // @ts-ignore
    window.dataLayer.push({
      event: 'virtualPageView', // Use a custom event name
      pagePath: location.pathname + location.search, // Send the path to GTM
    });

    // --- HubSpot Tracking ---
    // @ts-ignore
    if (window._hsq) {
      console.log('Tracking HubSpot PageView:', path);
      // @ts-ignore
      window._hsq.push(['setPath', path]);
      // @ts-ignore
      window._hsq.push(['trackPageView']);
    }

    console.log(`Navigating to ${path}`);
    navigationMethod(path);
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* toHome() {
  try {
    const settings = yield* select(selectors.raw.$rawSettings);
    const { firstPage = 'generators' } = settings;

    switch (firstPage) {
      case 'browse-ideas':
        yield invokeEvent('nav', { path: '/browse' });
        break;
      case 'create':
        yield invokeEvent('nav', { path: '/playground/blank' });
        break;
      case 'generators':
        yield invokeEvent('nav', { path: '/generators' });
        break;
      case 'image-to-3d':
        yield invokeEvent('nav', { path: '/labs/image-to-3d' });
        break;
      default:
        yield invokeEvent('nav', { path: '/generators' });
    }
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function useNavigationMethod() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setNavigationMethod(nav);
  }, [nav]);

  useEffect(() => {
    dispatch(actions.appState.patch({ path: location.pathname }));
    invokeEvent('onNav', {
      path: location.pathname,
    });
  }, [location]);
}

export function* root() {
  l('saga|saga.logs listening for nav custom event & NAVIGATE action');
  let channel;

  channel = customEventChannel('nav');
  yield takeEvery(channel, navEvent);
  channel = customEventChannel('onNav');
  yield takeEvery(channel, onNavigation);
  channel = customEventChannel('navToHome');
  yield takeEvery(channel, toHome);
}

export const saga = {
  id: 'sloyd.navigation',
  type: 'customEvent',
  root: root,
  trigger: {
    actionTypes: ['NAVIGATE'],
    eventNames: ['nav'],
  },
};
